module.exports = __webpack_public_path__ + "static/img/rta-a.81137dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/course/rta-a.png
// module id = bcOz
// module chunks = 1